module.exports = __webpack_public_path__ + "static/17-16fd2b40049522dc64637b9c13b7df0e.jpg";